import { render, staticRenderFns } from "./LogViewGlobal.vue?vue&type=template&id=190c54b4"
import script from "./LogViewGlobal.vue?vue&type=script&lang=js"
export * from "./LogViewGlobal.vue?vue&type=script&lang=js"
import style0 from "./LogViewGlobal.vue?vue&type=style&index=0&id=190c54b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports